"use strict";
// packages/types/src/audit.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditStatus = exports.AuditType = void 0;
var AuditType;
(function (AuditType) {
    AuditType["HACCP"] = "HACCP";
    AuditType["GFSI"] = "GFSI";
})(AuditType || (exports.AuditType = AuditType = {}));
var AuditStatus;
(function (AuditStatus) {
    AuditStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AuditStatus["COMPLETED"] = "COMPLETED";
    AuditStatus["RESOLVED"] = "RESOLVED";
    AuditStatus["ARCHIVED"] = "ARCHIVED";
})(AuditStatus || (exports.AuditStatus = AuditStatus = {}));
